// NWS_SMILELINE-1964: ページを開いたあと、サーバーに同意状態を確かめるのはどの画面遷移か、を決める。
// 画面（store・API）に依存しない判定だけをここに置く。

export interface AcceptanceCheckNavigation {
  /** 行き先がログインの必要な画面か */
  requiresAuth: boolean
  /** ログインしているか（トークンがあるか） */
  hasToken: boolean
  /** パスワードの変更が先に必要か（変更画面を優先する） */
  shouldUpdatePassword: boolean
  /** 行き先の画面名 */
  toName: string | null | undefined
}

export interface AcceptanceCheckDecision {
  /** このページの読み込みでの確認を済んだ扱いにするか */
  markChecked: boolean
  /** いまサーバーに確かめるか */
  callServer: boolean
}

/**
 * ページを読み込んでから、ログインした状態で最初にログインの必要な画面へ進むときに 1 回だけ確かめる。
 * - 最初に開いた画面がログイン不要の画面（招待リンクのプレビュー・規約の表示・ログイン画面など）でも、
 *   そのあと中の画面へ進んだときに確かめる（ここで済んだ扱いにしない）
 * - 2 回目以降の遷移（使っている途中）では確かめない
 * - 行き先が同意画面なら、同意画面が自分で確かめるので呼ばずに済んだ扱いにする
 * - パスワードの変更が先に必要なときは、変更が済んで中の画面へ進むときまで持ち越す
 */
export function decideAcceptanceCheck(
  alreadyChecked: boolean,
  nav: AcceptanceCheckNavigation
): AcceptanceCheckDecision {
  if (alreadyChecked || !nav.requiresAuth || !nav.hasToken || nav.shouldUpdatePassword) {
    return { markChecked: false, callServer: false }
  }
  return { markChecked: true, callServer: nav.toName !== 'acceptance' }
}
